import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import activityLogService from '../services/activity-log.service';
import {setMessage} from './message';
export const fetchActivityLogList = createAsyncThunk(
  'activityLog/fetchActivityLogList',
  async ({ page = 1, pageSize, search = '', ordering = '' }, thunkAPI) => {
    try {
      const response = await activityLogService.getActivityLogList(page, pageSize, search, ordering);
      return {
        ...response.data,
        page, 
      };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const searchActivityLog = createAsyncThunk(
  'activityLog/searchActivityLog',
  async ({ search, page = 1, pageSize = 10 }, thunkAPI) => {
    try {
      const response = await activityLogService.getActivityLogList(page, pageSize, search, '');
      return {
        ...response.data,
        page,
        search, 
      };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);




export const createActivityLog = createAsyncThunk(
  'activityLog/createActivityLog',
  async (activityData, thunkAPI) => {
    try {
      const response = await activityLogService.createActivityLog(activityData);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const resetDieCategoryListThunk = () => dispatch => {
  return new Promise(resolve => {
    dispatch(resetDieCategoryList()); 
    resolve(); 
  });
};

const initialState = {
  data: [],
  list: [],
  loading: false,
  totalpage: 0,
  currentpage: 1,
  totalRecord: 0,
  status: 'idle',
   searchTerm: '',
  error: null,
  hasMore: true,
};

const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetDieCategoryList: (state) => {
      state.list = [];
      state.currentPage = 1;
      state.searchTerm = '';
      state.hasMore = true;
    },
    resetCurrentCategoryPage: (state) => {
      state.currentPage = 1;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
  extraReducers: (builder) => {
   
    builder
      .addCase(fetchActivityLogList.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchActivityLogList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results?.data || [];
        state.list = action.payload.results?.data || [];
        state.totalRecord = action.payload.count || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.totalDie = action.payload.total_die_count || 0;
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.error = null;
      })
      .addCase(fetchActivityLogList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });

    
    builder
      .addCase(searchActivityLog.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(searchActivityLog.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results?.data || [];
        state.list = action.payload.results?.data || [];
        state.totalRecord = action.payload.count || 0;
        state.totalPages = action.payload.totalPages || 0;
        state.totalDie = action.payload.total_die_count || 0;
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.searchTerm = action.payload.search || '';
        state.error = null;
      })
      .addCase(searchActivityLog.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });

    
    builder
      .addCase(createActivityLog.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(createActivityLog.fulfilled, (state) => {
        state.status = 'succeeded';
        state.loading = false;
        state.error = null;
      })
      .addCase(createActivityLog.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setLoading, resetDieCategoryList, resetCurrentCategoryPage, setSearchTerm } =
  activityLogSlice.actions;
export default activityLogSlice.reducer;